<template>
  <div>
    <b-row class="no-gutters my-3">
      <b-col lg="6">
        <b-input-group>
          <b-form-input
            v-model="filter.postName"
            placeholder="Search Name"
            @keydown.enter="handleSearch"
          />
          <b-input-group-append>
            <b-button @click="handleSearch" class="search-button">
              <font-awesome-icon icon="search" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col lg="6" class="text-center text-sm-right"
        ><router-link :to="`/live/create/${postTypeId}/0`">
          <button class="create-button">
            <font-awesome-icon icon="plus-square" />
            <span class="ml-2"> CREATE</span>
          </button>
        </router-link></b-col
      >
    </b-row>
    <b-row class="main-theme no-gutters px-3 px-sm-0 ">
      <b-col>
        <b-table
          class="table-list"
          striped
          responsive
          hover
          :items="items"
          :fields="fields"
          :busy="isBusy"
          show-empty
          empty-text="ไม่พบข้อมูล"
        >
          <template v-slot:table-busy>
            <div class="text-center text-black my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(nameAndTags)="data">
            <div class="d-flex justify-content-center">
              {{ data.item.name }}
            </div>
            <div class="d-flex justify-content-center">
              <span
                class="word"
                v-for="(item, index) in data.item.keyword"
                :key="index"
                >{{ item }}</span
              >
            </div>
          </template>

          <template v-slot:cell(postTypeId)="data">
            <div class="d-flex justify-content-center">
              {{ data.item.postTypeId == 1 ? "Live" : "" }}
              {{ data.item.postTypeId == 2 ? "Post" : "" }}
            </div>
          </template>
          <template v-slot:cell(createdTime)="data">
            <div class="d-flex justify-content-center">
              {{ new Date(data.item.createdTime) | moment($formatDate) }} 
              <br />
              ({{ new Date(data.item.createdTime) | moment($formatTime) }})
            </div>
          </template>
          <template v-slot:cell(postCreatedTime)="data">
            <div class="d-flex justify-content-center">
              {{ new Date(data.item.postCreatedTime) | moment($formatDate) }} 
              <br />
              ({{ new Date(data.item.postCreatedTime) | moment($formatTime) }})
            </div>
          </template>
          <template v-slot:cell(updatedTime)="data">
            <div class="d-flex justify-content-center">
              {{ new Date(data.item.updatedTime) | moment($formatDate) }} 
              <br />
              ({{ new Date(data.item.updatedTime) | moment($formatTime) }})
            </div>
          </template>
          <template v-slot:cell(id)="data">
            <div class="d-flex justify-content-center">
              <router-link :to="'/live/detail/' + data.item.id">
                <b-button variant="link" class="text-warning px-1 py-0">
                  <font-awesome-icon icon="eye" class="text-primary" title="View" />
                </b-button>
              </router-link>
              <router-link :to="`/live/edit/${postTypeId}/${data.item.id}`">
                <b-button variant="link" class="text-warning px-1 py-0">
                  <font-awesome-icon icon="pencil-alt" class="text-warning" title="Edit" />
                </b-button>
              </router-link>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row class="no-gutters px-3 px-sm-0">
      <b-col
        class="
          form-inline
          justify-content-center justify-content-sm-between
        "
      >
        <div v-if="rows > 0" class="my-auto">
          Showing {{ startPage | numeral("0,0") }} to {{ endPage | numeral("0,0") }} of {{ rows | numeral("0,0") }} entires
        </div>
        <div v-else class="my-auto">{{ rows || 0 }} entire</div>
        <div class="d-sm-flex m-3">
          <b-pagination
            v-model="filter.paging.pageNo"
            :total-rows="rows"
            :per-page="filter.paging.perPage"
            class="m-md-0"
            @change="pagination"
            align="center"
          ></b-pagination>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    pageId: {
      type: String,
      required: true,
    },
    postTypeId: {
      type: Number,
      require: true,
    },
    instagramId: {
      type: [ String, Number ],
      require: false,
    }
  },
  data() {
    return {
      fields: [
        {
          key: "createdTime",
          label: "Date / Time Create",
          class: "w-180px",
        },
        {
          key: "postTypeId",
          label: "Type",
          class: "w-100px",
        },
        {
          key: "nameAndTags",
          label: "Live name / Tags",
          class: "w-160px",
        },
        {
          key: "postCreatedTime",
          label: "Publish date",
          class: "w-100px",
        },
        {
          key: "likeCount",
          label: "Like",
          class: "w-100px",
        },
        {
          key: "commentCount",
          label: "Comment",
          class: "w-100px",
        },
        {
          key: "orderCount",
          label: "Confirm",
          class: "w-100px",
        },
        {
          key: "updatedTime",
          label: "Last Update",
          class: "w-100px",
        },
        {
          key: "statusName",
          label: "Status",
          class: "w-100px",
        },
        {
          key: "id",
          label: "Action",
          class: "w-action"
        },
      ],
      filter: {
        postName: "",
        postTypeId: null,
        pageId: null,
        instagramId: null,
        paging: {
          pageNo: 1,
          perPage: 10,
        },
      },
      items: [],
      rows: 0,
      startPage: 1,
      endPage: 10,
    };
  },
  async created() {
    this.filter.pageId = this.pageId;
    this.filter.instagramId = this.instagramId;
    this.filter.postTypeId = this.postTypeId;
    await this.pagination(1)
  },
  methods: {
    async pagination(Page) {
      this.filter.paging.pageNo = Page;
      await this.getList();
      this.getShowingPage(Page);
    },
    handleSearch(e) {
      this.pagination(1)
    },
    async getList() {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/livePost/list`, this.filter)
        .then((data) => {
          this.isBusy = false;
          console.log("get list", data);
          if (data.result == 1) {
            this.items = data.detail.dataList;
            this.rows = data.detail.count;
          }
        });
    },
    async getShowingPage(page) {
      let result = await this.$getShowingPage(page, this.filter.paging);
      this.startPage = result.startPage;
      this.endPage = result.endPage;
    },
  },
};
</script>

<style></style>
